/* Method Golf Co. — Shop menu behaviour (snippets/method-shop-menu.liquid). Custom — safe to edit.
   A custom element, so it also wakes up when the header's lazy-loaded markup is swapped in.
   Focus note: the theme closes the mega menu on any focusout that leaves it, so nothing focusable
   is ever disabled or hidden while it may hold focus (arrows use aria-disabled). */
(function () {
  if (customElements.get('method-shop-menu')) return;
  const reduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class MethodShopMenu extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tabs = Array.from(this.querySelectorAll('[data-msm-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-msm-panel]'));
      this.alls = Array.from(this.querySelectorAll('[data-msm-all]'));
      this.pill = this.querySelector('[data-msm-pill]');
      this.arrows = Array.from(this.querySelectorAll('[data-msm-arrow]'));
      this.index = 0;
      if (!this.tabs.length) return;

      this.tabs.forEach((t) => t.addEventListener('click', () => this.select(Number(t.dataset.msmTab))));
      this.querySelector('[data-msm-seg]').addEventListener('keydown', (e) => {
        const k = e.key;
        if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
        e.preventDefault();
        const last = this.tabs.length - 1;
        const next = k === 'Home' ? 0 : k === 'End' ? last : (this.index + (k === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      });
      this.arrows.forEach((a) => a.addEventListener('click', () => {
        if (a.getAttribute('aria-disabled') === 'true') return;
        const track = this.track();
        if (track) track.scrollBy({ left: Number(a.dataset.msmArrow) * track.clientWidth * 0.92, behavior: reduce() ? 'auto' : 'smooth' });
      }));
      this.panels.forEach((p) => p.querySelector('[data-msm-track]')?.addEventListener('scroll', () => this.updateArrows(), { passive: true }));

      // Pill placement needs real layout; the panel is invisible until the menu opens
      this.classList.add('msm--instant');
      this.placePill();
      if (window.ResizeObserver) new ResizeObserver(() => { this.classList.add('msm--instant'); this.placePill(); this.updateArrows(); this.release(); }).observe(this);

      // Replay the tile entrance each time the mega menu opens
      const details = this.closest('details');
      if (details) {
        new MutationObserver(() => {
          if (details.hasAttribute('open')) {
            this.classList.add('msm--instant');
            this.placePill();
            this.release();
            this.enter(this.panels[this.index], 1);
            this.updateArrows();
          }
        }).observe(details, { attributes: true, attributeFilter: ['open'] });
      }
      this.updateArrows();
      this.release();
    }

    release() { requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('msm--instant'))); }

    track() { return this.panels[this.index]?.querySelector('[data-msm-track]'); }

    placePill() {
      const tab = this.tabs[this.index];
      if (!tab || !this.pill || !tab.offsetWidth) return;
      this.pill.style.setProperty('--msm-x', tab.offsetLeft + 'px');
      this.pill.style.setProperty('--msm-w', tab.offsetWidth + 'px');
    }

    select(next) {
      if (next === this.index || !this.panels[next]) return;
      const dir = next > this.index ? 1 : -1;
      const prev = this.panels[this.index];
      const incoming = this.panels[next];

      this.tabs.forEach((t, i) => {
        t.setAttribute('aria-selected', i === next ? 'true' : 'false');
        t.tabIndex = i === next ? 0 : -1;
      });
      this.alls.forEach((a) => { a.hidden = Number(a.dataset.msmAll) !== next; });
      this.index = next;
      this.placePill();

      if (reduce()) {
        prev.hidden = true;
        incoming.hidden = false;
      } else {
        // Old row lifts away while the new one slides in from the side you're heading to
        prev.classList.remove('is-entering', 'from-left');
        prev.classList.add('is-leaving');
        prev.hidden = true;
        clearTimeout(this._leaveT);
        this._leaveT = setTimeout(() => prev.classList.remove('is-leaving'), 300);
        incoming.hidden = false;
        this.enter(incoming, dir);
      }
      const track = incoming.querySelector('[data-msm-track]');
      if (track) track.scrollLeft = 0;
      this.updateArrows();
    }

    enter(panel, dir) {
      if (!panel || reduce()) return;
      panel.classList.remove('is-entering', 'from-left');
      void panel.offsetWidth; // restart the keyframes
      panel.classList.add('is-entering');
      if (dir < 0) panel.classList.add('from-left');
      clearTimeout(panel._enterT);
      panel._enterT = setTimeout(() => panel.classList.remove('is-entering', 'from-left'), 1400);
    }

    updateArrows() {
      const track = this.track();
      const [prevBtn, nextBtn] = this.arrows;
      if (!track || !prevBtn || !nextBtn) return;
      const max = track.scrollWidth - track.clientWidth;
      prevBtn.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', track.scrollLeft >= max - 2 ? 'true' : 'false');
      // Fade (never hide) so a focused arrow can't trigger the theme's focusout close
      this.querySelector('.msm__arrows').classList.toggle('is-idle', max <= 2);
    }
  }
  customElements.define('method-shop-menu', MethodShopMenu);
})();
